import React, { useCallback, useEffect, useState } from 'react';

import { GoogleMap, InfoWindow, Marker, useJsApiLoader } from '@react-google-maps/api';

import onteeBlackMarker from '../assets/img/onteeBlackMarker.png';
import onteeGreenMarker from '../assets/img/onteeGreenMarker.png';
import CoursesLinkListComponent from './lists/CoursesLinkListComponent';

let bounds;

const checkIfIsCords = (lat, lng) => lat !== 0 && lat > -85 && lat < 85 && lng > -180 && lng < 180;

const MapComponentNew = ({ locations, courseHover, center, zoom }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_MAP_KEY || 'AIzaSyAaxjReXqK5FMRoTZLRrEvUU1M2Xetf3E4',
  });

  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState(null);
  const [selectedGolfclubId, setSelectedGolfclubId] = useState(courseHover);

  useEffect(() => {
    setSelectedGolfclubId(courseHover);
  }, [courseHover]);

  useEffect(() => {
    if (locations?.length > 0) {
      // TODO: All courses is shown. Filter out unique golf clubs
      const mrks = locations.filter(l => checkIfIsCords(l.latitude, l.longitude));
      setMarkers(mrks);
    }
  }, [locations]);

  useEffect(() => {
    if (center) return;

    if (map && markers) {
      bounds = new window.google.maps.LatLngBounds();
      markers
        ?.filter(mrk => mrk.marked)
        .forEach(mrk => bounds.extend(new window.google.maps.LatLng(mrk.latitude, mrk.longitude)));
      map.fitBounds(bounds);
    }
  }, [center, map, markers]);

  const onLoad = useCallback(m => {
    setMap(m);
  }, []);

  return (
    isLoaded &&
    markers && (
      <GoogleMap
        mapContainerStyle={{ height: 500 }}
        onLoad={onLoad}
        options={{ maxZoom: 17, zoom: zoom, center: center }}
        onClick={() => setSelectedGolfclubId(null)}
      >
        {markers?.map(m => (
          <MyMarker
            key={m.id}
            club={m}
            onClick={setSelectedGolfclubId}
            showInfoWindow={m.id === selectedGolfclubId}
          />
        ))}
      </GoogleMap>
    )
  );
};

export default MapComponentNew;

function MyMarker({ club, onClick, showInfoWindow }) {
  return (
    <Marker
      key={club.id}
      position={{ lat: club.latitude, lng: club.longitude }}
      options={{
        icon: {
          url: club.marked ? onteeGreenMarker : onteeBlackMarker,
          scaledSize: { width: 24, height: 31 },
          size: { width: 24, height: 31 },
        },
      }}
      onClick={() => onClick(club.id)}
    >
      {showInfoWindow && (
        <InfoWindow
          position={{ lat: club.latitude, lng: club.longitude }}
          onCloseClick={() => onClick(null)}
        >
          <div className="m-2 fw-medium">
            <div className="mb-2 fs-6">{club.name}</div>
            <CoursesLinkListComponent club={club} />
          </div>
        </InfoWindow>
      )}
    </Marker>
  );
}
